[
  {
    "id": "GET-VER-L3-001",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Op school zitten 200 kinderen. 50% van de kinderen komt op de fiets. Hoeveel kinderen zijn dat?",
    "options": [
      "100 kinderen",
      "50 kinderen",
      "20 kinderen",
      "150 kinderen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-HELFT",
    "explanation": "50% is precies de helft. De helft van 200 is 100.",
    "distractorExplanations": {
      "1": "Je hebt het getal 50 genomen. Maar 50% betekent: de helft!",
      "2": "Dit is 10% (een tiende deel).",
      "3": "Dit is 75% (driekwart)."
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 1,
        "denominator": 2,
        "label": "50% = de helft",
        "visualType": "pizza",
        "usePizza": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VER-L3-002",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Sanne wil een game kopen van € 40,-. Ze heeft al $\\frac{3}{4}$ deel gespaard. Hoeveel euro heeft ze al?",
    "options": [
      "€ 30,-",
      "€ 10,-",
      "€ 20,-",
      "€ 35,-"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Eerst reken je een kwart uit: 40 : 4 = 10. Ze heeft 3 kwarten, dus: 3 $\\times$ 10 = 30 euro.",
    "distractorExplanations": {
      "1": "Dit is maar één kwart! Ze heeft al drie kwarten gespaard.",
      "2": "Dit is de helft. Maar driekwart is meer dan de helft!",
      "3": "Reken stap voor stap: eerst 40 : 4 = 10, dan 10 $\\times$ 3 = 30."
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 3,
        "denominator": 4,
        "label": "3 van de 4 delen = €30",
        "visualType": "chocolate",
        "usePizza": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VGL-L3-002",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Zet van groot naar klein: $\\frac{2}{3}$, $\\frac{5}{6}$, $\\frac{3}{4}$",
    "options": [
      "$\\frac{5}{6}$, $\\frac{3}{4}$, $\\frac{2}{3}$",
      "$\\frac{3}{4}$, $\\frac{5}{6}$, $\\frac{2}{3}$",
      "$\\frac{2}{3}$, $\\frac{3}{4}$, $\\frac{5}{6}$",
      "$\\frac{3}{4}$, $\\frac{2}{3}$, $\\frac{5}{6}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "Van groot naar klein: $\\frac{5}{6}$ (grootste), $\\frac{3}{4}$ = $\\frac{9}{12}$, $\\frac{2}{3}$ = $\\frac{8}{12}$ (kleinste). Maak de onderkant gelijk om te vergelijken!",
    "distractorExplanations": {
      "1": "Niet helemaal. $\\frac{5}{6}$ is het grootst, dat klopt!",
      "2": "Dit is van klein naar groot! De vraag is van groot naar klein.",
      "3": "Bijna! Maar $\\frac{3}{4}$ is groter dan $\\frac{2}{3}$."
    }
  },
  {
    "id": "GET-OPT-L3-001",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Reken kolomsgewijs uit: 1.847 + 2.956 =",
    "options": [
      "4.803",
      "4.793",
      "4.813",
      "3.803"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Grote getallen kolomsgewijs optellen met meerdere keren overhouden.\nEenheden: 7 + 6 = 13. Schrijf 3, onthoud 1.\nTientallen: 4 + 5 = 9, plus 1 = 10. Schrijf 0, onthoud 1.\nHonderdtallen: 8 + 9 = 17, plus 1 = 18. Schrijf 8, onthoud 1.\nDuizendtallen: 1 + 2 = 3, plus 1 = 4.\nHet antwoord is 4.803.",
    "distractorExplanations": {
      "1": "Rekenfoutje bij het overhouden. Check elke kolom goed! Let op: 4 + 5 + 1 (onthouden) = 10, schrijf 0 op.",
      "2": "Je bent een keer vergeten de onthouden 1 erbij te tellen.",
      "3": "Je vergat de onthouden 1 bij de duizendtallen erbij te tellen. 1 + 2 = 3, maar er was nog 1 onthouden, dus het wordt 4."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 1847,
        "operand2": 2956,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L3-002",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Reken kolomsgewijs uit: 3.456 + 2.789 =",
    "options": [
      "6.245",
      "6.235",
      "6.145",
      "5.245"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Grote getallen kolomsgewijs optellen met meerdere keren overhouden.\nEenheden: 6 + 9 = 15. Schrijf 5, onthoud 1.\nTientallen: 5 + 8 = 13, plus 1 = 14. Schrijf 4, onthoud 1.\nHonderdtallen: 4 + 7 = 11, plus 1 = 12. Schrijf 2, onthoud 1.\nDuizendtallen: 3 + 2 = 5, plus 1 = 6.\nHet antwoord is 6.245.",
    "distractorExplanations": {
      "1": "Rekenfoutje bij het overhouden. Check elke kolom goed!",
      "2": "Je bent een keer vergeten de onthouden 1 erbij te tellen bij de honderdtallen!",
      "3": "Je vergat de onthouden 1 bij de duizendtallen erbij te tellen. 3 + 2 = 5, maar er was nog 1 onthouden, dus het wordt 6."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 3456,
        "operand2": 2789,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-PROC-L3-003",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "25% van 360 is ...",
    "options": [
      "90",
      "80",
      "100",
      "120"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-KWART",
    "explanation": "25% is een kwart. 360 : 4 = 90.",
    "distractorExplanations": {
      "1": "Je deelde door 4 maar vergiste je in de uitkomst.",
      "2": "Dit is ongeveer 28%. 25% is lager.",
      "3": "Dit is een derde van 360, maar 25% is een kwart."
    }
  },
  {
    "id": "GET-PROC-L3-004",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "10% van 450 is 45. Hoeveel is 15% van 450?",
    "options": [
      "67,5",
      "45",
      "75",
      "90"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-SAMENGESTELD",
    "explanation": "10% is 45 en 5% is de helft daarvan (22,5). Samen is dat 67,5.",
    "distractorExplanations": {
      "1": "Dat is alleen 10%. Je mist nog 5%.",
      "2": "Je nam 20% van 450. 15% is minder.",
      "3": "Je vermenigvuldigde 45 met 2. Maar 15% is 10% + 5%."
    }
  },
  {
    "id": "GET-BREUK-L3-003",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Welke breuk is gelijk aan 0,4?",
    "options": [
      "$\\frac{2}{5}$",
      "$\\frac{1}{4}$",
      "$\\frac{4}{5}$",
      "$\\frac{3}{10}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_decimaal",
    "familyId": "GET-BREUK-DECIMAAL",
    "explanation": "0,4 = 4 tienden. Dat is $\\frac{4}{10}$ en dat is gelijk aan $\\frac{2}{5}$.",
    "distractorExplanations": {
      "1": "$\\frac{1}{4}$ is 0,25, dat is kleiner dan 0,4.",
      "2": "$\\frac{4}{5}$ is 0,8, dat is groter dan 0,4.",
      "3": "$\\frac{3}{10}$ is 0,3."
    }
  },
  {
    "id": "GET-VGL-L3-003",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Welke breuk is het kleinst?",
    "options": [
      "$\\frac{3}{5}$",
      "$\\frac{2}{3}$",
      "$\\frac{4}{7}$",
      "$\\frac{5}{8}$"
    ],
    "correctAnswer": 2,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "$\\frac{4}{7}$ is ongeveer 0,57. De andere breuken zijn groter dan 0,6.",
    "distractorExplanations": {
      "0": "$\\frac{3}{5}$ is 0,6, dat is groter.",
      "1": "$\\frac{2}{3}$ is ongeveer 0,67, dus groter.",
      "3": "$\\frac{5}{8}$ is 0,625, dus groter."
    }
  },
  {
    "id": "GET-OPT-L3-003",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Reken kolomsgewijs uit: 4.205 + 3.690 =",
    "options": [
      "7.895",
      "7.885",
      "7.905",
      "6.895"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Tel de eenheden: 5 + 0 = 5. Tientallen: 0 + 9 = 9. Honderdtallen: 2 + 6 = 8. Duizendtallen: 4 + 3 = 7. Dus 7.895.",
    "distractorExplanations": {
      "1": "Je maakte een fout bij de honderdtallen of tientallen.",
      "2": "Je vergiste je bij de tientallen: 0 + 9 = 9, niet 10.",
      "3": "Je telde de duizendtallen verkeerd op."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 4205,
        "operand2": 3690,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L3-004",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Reken uit: 3.000 - 1.846 =",
    "options": [
      "1.154",
      "1.254",
      "1.146",
      "1.204"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-LENEN",
    "explanation": "Leen door de nullen: 3000 wordt 2.999. Dan 9 - 6 = 3, 9 - 4 = 5, 9 - 8 = 1, 2 - 1 = 1. Dus 1.154.",
    "distractorExplanations": {
      "1": "Je leende niet door alle nullen.",
      "2": "Je verwisselde de tientallen en eenheden.",
      "3": "Je leende maar één keer, maar je moet door alle nullen lenen."
    }
  },
  {
    "id": "GET-MEERSTAPS-L3-002",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Een bakker bakt 120 broodjes. 35% wordt in de ochtend verkocht. Hoeveel broodjes blijven over?",
    "options": [
      "78",
      "42",
      "84",
      "88"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "meerstaps",
    "familyId": "GET-MEERSTAPS",
    "explanation": "35% van 120 is 42 (10% = 12, 30% = 36, plus 5% = 6). Over blijft 120 - 42 = 78.",
    "distractorExplanations": {
      "1": "Dat is het aantal verkochte broodjes, niet wat overblijft.",
      "2": "Je nam 30% in plaats van 35%.",
      "3": "Je rekende 40% in plaats van 35%."
    }
  },
  {
    "id": "GET-METEN-L3-001",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "1$\\frac{1}{2}$ liter is hoeveel milliliter?",
    "options": [
      "1500 ml",
      "1250 ml",
      "1050 ml",
      "1150 ml"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "meten",
    "familyId": "GET-METEN-EENHEDEN",
    "explanation": "1 liter is 1000 ml en een halve liter is 500 ml. Samen is dat 1500 ml.",
    "distractorExplanations": {
      "1": "Je nam een kwart liter in plaats van een halve liter.",
      "2": "Je telde 50 ml in plaats van 500 ml.",
      "3": "Je rekende 1,15 liter, maar het is 1,5 liter."
    }
  },
  {
    "id": "GET-VERH-L3-001",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "In een klas is de verhouding jongens : meisjes = 2 : 3. Er zijn 25 leerlingen. Hoeveel jongens zijn er?",
    "options": [
      "10",
      "12",
      "15",
      "8"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "Samen zijn er 2 + 3 = 5 delen. 25 : 5 = 5 per deel. Jongens zijn 2 delen: 2 × 5 = 10.",
    "distractorExplanations": {
      "1": "Je nam 3 delen in plaats van 2 delen.",
      "2": "Je telde alle delen bij elkaar op in plaats van te delen.",
      "3": "Je deelde door 3 in plaats van door 5."
    }
  },
  {
    "id": "GET-AFR-L3-001",
    "module": "Getalbegrip",
    "difficulty": 105,
    "question": "Rond 7,482 af op twee decimalen.",
    "options": [
      "7,48",
      "7,49",
      "7,42",
      "7,50"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "afronden",
    "familyId": "GET-AFRONDEN",
    "explanation": "Kijk naar de derde decimaal: dat is 2. Omdat die kleiner is dan 5, blijft 7,48.",
    "distractorExplanations": {
      "1": "Je rondde naar boven af, maar de derde decimaal is 2.",
      "2": "Je rondde af op één decimaal in plaats van twee.",
      "3": "Je sprong te ver naar boven."
    }
  }
]